import React, { memo, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { generatePath } from 'react-router'
import { HeaderBarStyle } from './styled'
import { Button, Image, Section } from '../../components'
import { ROUTE_PATH } from '../../helpers'
import { BASE_API } from '../../apiService'

export const HeaderBar = props => {
  const { user, role, logout } = props

  const _roleMapper = role => {
    // return role
    switch (role) {
      case '1':
        return 'Admin'
      case '2':
        return 'System Admin'
      case '3':
        return 'Admin'
      case '4':
        return 'User'
      case '5':
        return 'Admin'
      case '6':
        return 'Admin'
      case '7':
        return 'Risk Management'
      default:
        return 'Admin'
    }
  }

  const IMAGE_PATH = `${BASE_API}/cross_procurement`

  const userRole = useMemo(() => {
    return user.roles
      ? user.roles.map(r => r.name).join(' | ')
      : _roleMapper(role)
  }, [user])

  return (
    <HeaderBarStyle
      className={`header-bar${user && user.id ? ' is-offset' : ''}`}
    >
      <Section className="header-title">
        {!user.id ? (
          <Link className="logo-link" to={generatePath(ROUTE_PATH.HOME.LINK)}>
            <Image
              src={IMAGE_PATH}
              alt="logo"
              className="app-logo"
              style={{ maxWidth: '50px' }}
            />
          </Link>
        ) : null}
        {!user.id ? (
          <React.Fragment>
            <Section className="separate-line" />
            <Section id="app_title" className="app-title">
              {role}
            </Section>
          </React.Fragment>
        ) : null}
      </Section>
      {user && user.id ? (
        <Section className="header-user">
          <Section className="user">
            <Section className="name">
              <Section id="user_name" className="span">
                {user.full_name}
              </Section>
            </Section>
            <Section className="role">
              <Section id="user_role" className="span">
                {userRole}
              </Section>
            </Section>
          </Section>
          <Button
            id="logout_button"
            className="link logout"
            title="Logout"
            onClick={logout}
          >
            <svg className="logout-icon" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
              <path d="M16 17l5-5-5-5" />
              <path d="M21 12H9" />
            </svg>
          </Button>
        </Section>
      ) : null}
    </HeaderBarStyle>
  )
}
